import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as ol from 'ol/'
import {transform} from 'ol/proj';
import GeoJSON from 'ol/format/GeoJSON';
import {Stroke, Style} from 'ol/style';
import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import WKT from 'ol/format/WKT';
import * as ol_style from 'ol/style'
import IconAnchorUnits from 'ol/style/IconAnchorUnits'

import WithRender from './IsochroneTool.html';
import { StyleFunction } from 'ol/style/Style';
import Point from 'ol/geom/Point';
import * as ol_layer from 'ol/layer'

import * as ol_interaction from 'ol/interaction';
import * as ol_source from 'ol/source'


import { GoatClient } from '../GoatClient';

@WithRender
@Component({
    components: {

    }
})
export default class IsochroneTool extends Vue {

    @Prop()
    map!: ol.Map;

    @Prop()
    isochroneFeature!:ol.Feature

    @Prop()
    trigger!:string

    @Prop()
    config!:any

    @Prop()
    goatApi!:string

    //################## isochrone style and name ##################
    colorCode:string = "#4C4CFF"
    markerIcon: string = "/img/location.svg"  //"https://metropolatlas.digitale-mrn.de/images/icons/explosion.svg"
    activeIsochrones:string = "Isochrone"
    coords:any = null

    legend: any = {}
    //################## isochrone style and name ##################

    vectorLayer:VectorLayer = new VectorLayer(
        {source: new VectorSource(),
        }
        );

    @Watch('config', {deep:true})
    onConfigChange(){

        if(this.map == undefined){
            return
        }
        if(this.map.getLayers().getArray().filter(layer => layer.get('id') === this.activeIsochrones).length != 0){
            this.createLegend()
            this.requestIsochrone(this.coords)
        }
        
    }

    @Watch('trigger')
    triggerChange(){
        
        // typecheck with instance of not working
        if(this.map == undefined){
            return
        }

        // maybe change this to 
        if(this.trigger.includes("draw_isochrone")){
            this.map.once('singleclick', this.init)
        }

    }

    init(evt: any){

        this.createLegend()
        let coords:Array<number> = this.getCoords(evt)
        this.coords = coords
        this.requestIsochrone(coords)
        this.makeIsochroneDraggable()

        
    }

    makeIsochroneDraggable(){

        var myTranslate = new ol_interaction.Translate({
            filter: function(feature:any, layer:ol_layer.Layer){
                //filter for Startpoint
                if(layer.get('id') == ('Isochrone') && feature.getGeometry().getType()=='Point'){
                    return true
                }
                else{
                    return false
                }
            }
        });

        this.map.addInteraction( myTranslate );
        myTranslate.on("translatestart", this.removeIsochrone)
        // ... and then to get the coordinates of the icon after it's dragged
        myTranslate.on( "translateend", this.HandleMapIconDrag);
    }
    createLegend(){

        this.legend = {
            "Legend": [
                {
                    //"layerName": layerConfig.id,
                    "title": this.activeIsochrones,
                    "rules": [
                        {
                            "name": "rule1",
                            "title": "Startpunkt",
                            "abstract": "",
                            "symbolizers": [
                                {
                                    "Point": {
                                        "title": "Isochronen Startpunkt",
                                        "abstract": "",
                                        "url": this.markerIcon,
                                        "size": "30",
                                        "opacity": "1.0",
                                        "rotation": "0.0",
                                    }
                                }
                            ]
                        },
                        {
                            "name": "rule1",
                            "title": this.config.minutes.toString()+ " Minuten Isochrone",
                            "abstract": "",
                            "symbolizers": [
                                {
                                    "Line": {
                                        "stroke": this.colorCode,
                                        "stroke-width": "2",
                                        "stroke-opacity": "1",
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    
    }

    getCoords(evt: any){

        let coords: Array<number> = transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326')

        return coords
    }

    async requestIsochrone(coords: any){

        let goatClient: GoatClient = new GoatClient(this.goatApi)

        goatClient.createIsochronePayload(coords, this.config.routing_profile, this.config.minutes, this.config.speed)

        let isochroneJSON:any = await goatClient.requestIsochrone()

        this.addStartPointtoGeoJsonInplace(isochroneJSON)

        let features: Array<ol.Feature> = new GeoJSON().readFeatures(isochroneJSON);

        features.forEach(function(feature:ol.Feature){

            feature.getGeometry()?.transform('EPSG:4326', 'EPSG:3857')            
        });
        
        this.$emit("update:isochroneFeature",features[1])

        this.layerSetter()

        this.vectorLayer.getSource().clear()
        this.vectorLayer.getSource().addFeatures(features)

        //check if layer already added, neccessary to update legend
        if(this.map.getLayers().getArray().filter(layer => layer.get('id') === this.activeIsochrones).length == 0){

            this.map.addLayer((this.vectorLayer as ol_layer.Vector))
        }

        this.$emit('update:trigger', 'gfi')

    }


    removeIsochrone(){

        let source:ol_source.Vector = this.vectorLayer.getSource()

        for(let feature of source.getFeatures()){
            if(feature.getGeometry()?.getType() == 'Polygon'){

                source.removeFeature(feature)
            }
        }
    }

    addStartPointtoGeoJsonInplace(isochroneJSON:any){


        let startPointWkt: any = isochroneJSON.features[0].properties.starting_point

        const format = new WKT();

        let startPoint: Point = <Point>format.readFeature(startPointWkt).getGeometry();
        let startPointCoords: Array<number> = startPoint.getCoordinates()

        let startPointFeature = {
            type:"Feature",
            "geometry": {
                type:"Point",
                coordinates: startPointCoords
            }
        }

        isochroneJSON.features.unshift(startPointFeature)

    }


    HandleMapIconDrag( e:any )
    {
        var p = e.features.getArray()[ 0 ].getGeometry().getCoordinates();
        p = transform( p, "EPSG:3857", "EPSG:4326" );
        this.coords = p
        this.requestIsochrone(p)        // p now holds the [ lon, lat ] value of the dragged point icon
    }

    layerSetter(){
        this.vectorLayer.set('id',this.activeIsochrones)
        this.vectorLayer.set('title',this.activeIsochrones)
        this.vectorLayer.set("showFeatureInfo", false)
        this.vectorLayer.setZIndex(4)
        this.vectorLayer.set('showLegend', true)
        this.vectorLayer.set('legend', this.legend)
        this.vectorLayer.set('showIsochroneInfoPanel', false)


        // style
        let icon:any = this.markerIcon

        let style:any  = {
            "Point":new Style({
                image: new ol_style.Icon({
                    anchor: [0.5, 0.5],
                    anchorXUnits: IconAnchorUnits.FRACTION,
                    anchorYUnits: IconAnchorUnits.FRACTION,
                    src: icon,
                    scale: 0.5,
                    crossOrigin: 'anonymous',
                })
            }),
            "Polygon":new Style({
                stroke: new Stroke({
                    color:"#4C4CFF",
                    width: 3,
                }),
                })
        }

        let styleFunction: StyleFunction = function(feature:any){

            return [style[feature.getGeometry().getType()]]
        }
        // set shit
        this.vectorLayer.setStyle(styleFunction)


    }

}


